import { render, staticRenderFns } from "./saasDetail.vue?vue&type=template&id=90f49412&scoped=true&"
import script from "./saasDetail.vue?vue&type=script&lang=js&"
export * from "./saasDetail.vue?vue&type=script&lang=js&"
import style0 from "./saasDetail.vue?vue&type=style&index=0&id=90f49412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f49412",
  null
  
)

export default component.exports